import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ConfigService } from '../config/config.service';
import { Observable, of } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class NotificacaoContratoService {
  private baseUrl: string;
  // Altere para false quando o backend estiver pronto
  private MOCK_MODE = false; 

  constructor(private http: HttpClient, private configService: ConfigService) {
    this.baseUrl = this.configService.pessoaApi;
  }

  /**
   * 1.1 Listar os tipos de notificação disponíveis
   */
  getTiposNotificacao(): Observable<any> {
    if (this.MOCK_MODE) {
      return of([
        { valor: 'SERVICOS_INICIAIS', descricao: 'Serviços Iniciais' },
        { valor: 'OPERACIONAL', descricao: 'Operacional' },
        { valor: 'MONITORACAO', descricao: 'Monitoração' },
        { valor: 'OBRAS', descricao: 'Obras' }
      ]);
    }
    return this.http.get(`${this.baseUrl}/v1/notificacoes/tipos`);
  }

  /**
   * 3.1 Cadastrar uma nova notificação
   */
  create(data: { idUsuario: string, tipoNotificacao: string }): Observable<any> {
    if (this.MOCK_MODE) {
      return of({ status: 'OK', message: 'Notificação cadastrada com sucesso.', id: 'new-uuid-123' });
    }
    return this.http.post(`${this.baseUrl}/v1/notificacoes`, data);
  }

  /**
   * 3.2 Listar as notificações com filtros
   */
  getNotificacoes(
    page: number = 0,
    size: number = 10,
    sortField: string = 'usuario',
    sortDirection: 'asc' | 'desc' = 'asc'
  ): Observable<any> {
    if (this.MOCK_MODE) {
      return of({
        content: [
          {
            id: 'uuid-notif-1',
            usuario: { id: '065a9c75-f9e6-49dd-9451-af8c8e3021da', nome: 'Alan Santos', email: 'AlanSantos@email.com', ativo: true },
            tipoNotificacao: { valor: 'OBRAS', descricao: 'Obras' }
          },
          {
            id: 'uuid-notif-2',
            usuario: { id: '9c90277b-8d47-4624-994a-b68a2f24f02e', nome: 'Bruno Santos', email: 'BrunoSantos@email.com', ativo: true },
            tipoNotificacao: { valor: 'OBRAS', descricao: 'Obras' }
          }
        ],
        totalElements: 1,
        pageNumber: page,
        pageSize: size
      });
    }

    const params = new HttpParams()
      .set('page', page.toString())
      .set('size', size.toString())
      .set('sortField', sortField)
      .set('sortDirection', sortDirection);

    return this.http.get(`${this.baseUrl}/v1/notificacoes`, { params });
  }

  /**
   * 3.3 Editar uma notificação
   */
  edit(idNotificacao: string, data: { idUsuario: string, tipoNotificacao: string }): Observable<any> {
    if (this.MOCK_MODE) {
      return of({ status: 'OK', message: 'Notificação editada com sucesso.', id: idNotificacao });
    }
    return this.http.put(`${this.baseUrl}/v1/notificacoes/${idNotificacao}`, data);
  }

  /**
   * 3.4 Excluir uma notificação
   */
  delete(idNotificacao: string): Observable<any> {
    if (this.MOCK_MODE) {
      return of({ status: 'OK', message: 'Notificação excluída com sucesso.', id: null });
    }
    return this.http.delete(`${this.baseUrl}/v1/notificacoes/${idNotificacao}`);
  }

  /**
   * 3.5 Listar histórico de uma notificação
   */
  getHistorico(
    idNotificacao: any ,
    page: number = 0,
    size: number = 10,
    sortField: string = 'data',
    sortDirection: 'asc' | 'desc' = 'asc'
  ): Observable<any> {
    if (this.MOCK_MODE) {
      return of({
        content: [
          {
            data: '2023-10-27T10:00:00',
            autor: 'Admin Sistema',
            operacao: 'ALTERAÇÃO',
            alteracoes: [
              { coluna: 'tipoNotificacao', valorAnterior: 'OBRAS', valorPosterior: 'OPERACIONAL' }
            ]
          }
        ],
        totalElements: 1,
        pageNumber: page
      });
    }

    const params = new HttpParams()
      .set('page', page.toString())
      .set('size', size.toString())
      .set('sortField', sortField)
      .set('sortDirection', sortDirection);

    return this.http.get(`${this.baseUrl}/v1/notificacoes/${idNotificacao}/historico`, { params });
  }
}